import styled from 'styled-components';

export const ListContainer = styled.div``;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
`;
